var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("PageWrapper", {
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "el-select",
              {
                ref: "selectRef",
                staticClass: "model-select",
                attrs: {
                  filterable: "",
                  remote: "",
                  "popper-append-to-body": "",
                  "reserve-keyword": "",
                  "automatic-dropdown": true,
                  "default-first-option": true,
                  placeholder: "请输入型号搜索",
                  "remote-method": _vm.remoteMethod,
                  loading: _vm.loading,
                },
                on: { change: _vm.handleChange },
                model: {
                  value: _vm.keyword,
                  callback: function ($$v) {
                    _vm.keyword = $$v
                  },
                  expression: "keyword",
                },
              },
              _vm._l(_vm.options, function (item) {
                return _c("el-option", {
                  key: item.value,
                  attrs: { label: item.label, value: item.value },
                })
              }),
              1
            ),
            _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    staticClass: "el-icon-plus custom-btn",
                    attrs: { type: "primary", size: "small" },
                    on: { click: _vm.handleAdd },
                  },
                  [_vm._v("新增型号")]
                ),
              ],
              1
            ),
            _c(
              "el-card",
              { staticClass: "model-card" },
              [
                _c(
                  "div",
                  {
                    staticClass: "clearfix",
                    attrs: { slot: "header" },
                    slot: "header",
                  },
                  [_c("span", [_vm._v("库存")])]
                ),
                _c(
                  "el-table",
                  {
                    staticClass: "model-table",
                    attrs: {
                      border: "",
                      fit: "",
                      "highlight-current-row": "",
                      data: _vm.inventory,
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { label: "ID", prop: "id" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "商品名称", prop: "title" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "型号", prop: "xhname", width: "150" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "品牌", prop: "source" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "含/未税", prop: "spzt" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    scope.row.spzt === "0" ? "未税" : "含税"
                                  ) +
                                  " "
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "库存数量", prop: "number" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "未税价格", prop: "wshui" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "含税价格", prop: "hshui" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "零售价", prop: "price" },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "自定义价格",
                        prop: "zdyprice",
                        width: "100",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "产地", prop: "address" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "包装", prop: "baozhuang" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "库房货位", prop: "kufang" },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "进货日期",
                        prop: "settime",
                        width: "120",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "供应商",
                        prop: "gongyingshang",
                        width: "220",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "操作", width: "90", fixed: "right" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            var $index = ref.$index
                            return [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    size: "mini",
                                    disabled:
                                      row.state === "T" ||
                                      _vm.disabledIndexes.includes(row.id),
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.addToDrawer(row, 1, $index)
                                    },
                                  },
                                },
                                [_vm._v("添加 ")]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-card",
              { staticClass: "model-card" },
              [
                _c(
                  "div",
                  {
                    staticClass: "clearfix",
                    attrs: { slot: "header" },
                    slot: "header",
                  },
                  [_c("span", [_vm._v("数据列表")])]
                ),
                _c(
                  "div",
                  [
                    _c("p", [_vm._v("品牌：")]),
                    _c(
                      "el-tag",
                      {
                        staticStyle: {
                          "margin-right": "3px",
                          cursor: "pointer",
                        },
                        attrs: {
                          type: "info",
                          effect: _vm.selectedSourceTag == 1 ? "dark" : "light",
                        },
                        on: { click: _vm.getAllSource },
                      },
                      [_vm._v("不限 ")]
                    ),
                    _vm._l(_vm.sourceData, function (item) {
                      return _c(
                        "el-tag",
                        {
                          staticStyle: { margin: "0 3px", cursor: "pointer" },
                          attrs: {
                            effect:
                              _vm.selectedSourceTag === item ? "dark" : "light",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.handleSource(item)
                            },
                          },
                        },
                        [_vm._v(_vm._s(item) + " ")]
                      )
                    }),
                  ],
                  2
                ),
                _c(
                  "div",
                  [
                    _c("p", [_vm._v("价格来源：")]),
                    _c(
                      "el-tag",
                      {
                        staticStyle: {
                          "margin-right": "3px",
                          cursor: "pointer",
                        },
                        attrs: {
                          type: "info",
                          effect:
                            _vm.selectedAddressTag == 2 ? "dark" : "light",
                        },
                        on: { click: _vm.getAllAddress },
                      },
                      [_vm._v("不限 ")]
                    ),
                    _vm._l(_vm.addressData, function (item) {
                      return _c(
                        "el-tag",
                        {
                          staticStyle: { margin: "0 3px", cursor: "pointer" },
                          attrs: {
                            type: "warning",
                            effect:
                              _vm.selectedAddressTag === item
                                ? "dark"
                                : "light",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.handleAddress(item)
                            },
                          },
                        },
                        [_vm._v(_vm._s(item) + " ")]
                      )
                    }),
                  ],
                  2
                ),
                _c(
                  "el-table",
                  {
                    staticClass: "model-table",
                    attrs: {
                      border: "",
                      fit: "",
                      "highlight-current-row": "",
                      data: _vm.data,
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { label: "ID", prop: "id" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "型号", prop: "xhname" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "品牌", prop: "source" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "含/未税", prop: "shui" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    scope.row.shui === "0" ? "未税" : "含税"
                                  ) +
                                  " "
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "价格", prop: "price" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "型号", prop: "renshu1" },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c(
                                "el-select",
                                {
                                  on: { change: _vm.updatePrices },
                                  model: {
                                    value: _vm.renshu1,
                                    callback: function ($$v) {
                                      _vm.renshu1 = $$v
                                    },
                                    expression: "renshu1",
                                  },
                                },
                                _vm._l(_vm.percentOptions, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.calcPrice(row.price, _vm.renshu1)
                                  ) +
                                  " "
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "型号", prop: "renshu2" },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c(
                                "el-select",
                                {
                                  on: { change: _vm.updatePrices },
                                  model: {
                                    value: _vm.renshu2,
                                    callback: function ($$v) {
                                      _vm.renshu2 = $$v
                                    },
                                    expression: "renshu2",
                                  },
                                },
                                _vm._l(_vm.percentOptions, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.calcPrice(row.price, _vm.renshu2)
                                  ) +
                                  " "
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "型号", prop: "renshu3" },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c(
                                "el-select",
                                {
                                  on: { change: _vm.updatePrices },
                                  model: {
                                    value: _vm.renshu3,
                                    callback: function ($$v) {
                                      _vm.renshu3 = $$v
                                    },
                                    expression: "renshu3",
                                  },
                                },
                                _vm._l(_vm.percentOptions, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.calcPrice(row.price, _vm.renshu3)
                                  ) +
                                  " "
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "型号", prop: "renshu4" },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c(
                                "el-select",
                                {
                                  on: { change: _vm.updatePrices },
                                  model: {
                                    value: _vm.renshu4,
                                    callback: function ($$v) {
                                      _vm.renshu4 = $$v
                                    },
                                    expression: "renshu4",
                                  },
                                },
                                _vm._l(_vm.percentOptions, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.calcPrice(row.price, _vm.renshu4)
                                  ) +
                                  " "
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "价格来源", prop: "address" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "创建时间", prop: "ArticleTime" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "操作", width: "90", fixed: "right" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            var $index = ref.$index
                            return [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    size: "mini",
                                    disabled:
                                      row.state === "T" ||
                                      _vm.disabledIndexes.includes(row.id),
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.addToDrawer(row, 2, $index)
                                    },
                                  },
                                },
                                [_vm._v("添加 ")]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-drawer",
              {
                attrs: {
                  title: "报价型号",
                  visible: _vm.drawerVisible,
                  size: _vm.getIsMobile ? "100%" : "30%",
                },
                on: {
                  "update:visible": function ($event) {
                    _vm.drawerVisible = $event
                  },
                },
              },
              [
                _c(
                  "el-table",
                  {
                    staticClass: "drawer-table",
                    attrs: { data: _vm.addedData, border: "" },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { prop: "xhname", label: "型号" },
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "source", label: "品牌" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "操作" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            var $index = ref.$index
                            return [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "danger", size: "mini" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.removeFromDrawer(row, $index)
                                    },
                                  },
                                },
                                [_vm._v(" 删除 ")]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "dialog-footer" },
                  [
                    _c(
                      "el-button",
                      {
                        staticStyle: { "margin-right": "5px" },
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.handleQuotation(_vm.addedData)
                          },
                        },
                      },
                      [_vm._v("生成报价单")]
                    ),
                    _c(
                      "el-button",
                      {
                        staticStyle: { "margin-right": "5px" },
                        attrs: { type: "danger" },
                        on: { click: _vm.handleClear },
                      },
                      [_vm._v("清空")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("AddPage", {
              ref: "addPageRef",
              attrs: { dialog: _vm.dialog },
              on: { submit: _vm.handleAddSubmit, close: _vm.handleAddClose },
            }),
            _c("CreateQuotation", {
              attrs: { dialog: _vm.quotationDialog, data: _vm.quotationData },
              on: { close: _vm.quotationClose },
            }),
            _c(
              "el-button",
              {
                staticClass: "add-btn",
                attrs: { type: "primary", plain: "" },
                on: { click: _vm.handleAddXname },
              },
              [
                _vm._v(
                  "已添加（" +
                    _vm._s(_vm.addedData.length || _vm.addedNum) +
                    "） "
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }